module.exports = __webpack_public_path__ + "static/media/activation.1b89c00d.png";